import type { RsvpWireUserStatus } from "@/lib/rsvp-api"
import { clearRsvpStatus, updateRsvp } from "@/lib/timeline-store"

/** Align local timeline RSVP cache with server wire status (badges / Attending tab). */
export function syncTimelineLocalRsvpFromServer(
  eventId: string,
  userStatus: RsvpWireUserStatus,
): void {
  const id = eventId.trim()
  if (!id) return
  if (userStatus === "no_response") {
    clearRsvpStatus(id)
    return
  }
  if (userStatus === "declined") {
    updateRsvp(id, "not_going")
    return
  }
  updateRsvp(id, userStatus)
}
